import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, useParams } from 'react-router-dom';
import CS from './CS'; 
import IFP from './IFP'; 

const App = () => {
  const [files, setFiles] = useState({ providers: [], drugs: [], plans: [] });

  const fetchFilesFromDirectory = async (directoryPath) => {  
    try {  
      const response = await fetch(`/api/files/${directoryPath}`);
      if (!response.ok) {
        throw new Error('Failed to fetch files');
      }
      const fileList = await response.json();
      
      // Transform files to use streaming URLs for non-external files
      const transformFiles = (files, category) => {
        return files.map(file => {
          if (file.isExternal) {
            // External URLs (from CSV/JSON links) - keep as-is
            return file;
          }
          // Internal blob files - use streaming endpoint
          return {
            ...file,
            url: `/api/stream/${file.blobPath}`
          };
        });
      };

      const transformedFiles = {
        providers: transformFiles(fileList.providers, 'providers'),
        drugs: transformFiles(fileList.drugs, 'drugs'),
        plans: transformFiles(fileList.plans, 'plans')
      };

      console.log("Final File List:", transformedFiles);
      setFiles(transformedFiles);
  
    } catch (error) {
      console.error("Error fetching files:", error);
    }
  };

  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes("/CS")) {
      fetchFilesFromDirectory("ui/cs/");
    } else if (location.pathname.includes("/IFP")) {
      fetchFilesFromDirectory("ui/ifp/");
    }
  }, [location.pathname]);

  const FileDownloader = ({files}) => {
    const { fileName } = useParams();
    console.log("FileDownloader", fileName);
    
    const file = files.providers.find(f => f.name === fileName) || 
                 files.drugs.find(f => f.name === fileName) || 
                 files.plans.find(f => f.name === fileName);

    console.log("files", files);

    useEffect(() => {
      if (file) {
        window.location.href = file.url;
      }   
    }, [file]);

    // return file ? <div>Downloading {file.name}...</div> : <div>Downloading/Redirecting</div>;
    return null
    
  };

  // const FileDownloader = ({ files }) => {
  //   const { fileName } = useParams();
  //   const [fileContent, setFileContent] = useState(null);
  //   const [loading, setLoading] = useState(true);
  //   const [error, setError] = useState(null);
  
  //   const file = files.providers.find(f => f.name === fileName) || 
  //                files.drugs.find(f => f.name === fileName) || 
  //                files.plans.find(f => f.name === fileName);

  //                console.log("file", file.name);
  
  //   useEffect(() => {
  //     if (file && file.name && file.name.includes('Drugs')) {
  //       window.location.href = file.url;
  //     }

  //     else if (file) {
  //       fetch(file.url)
  //         .then(response => {
  //           if (!response.ok) {
  //             throw new Error('Network response was not ok');
  //           }
  //           return response.json();
  //         })
  //         .then(data => {
  //           setFileContent(data);
  //           setLoading(false);
  //         })
  //         .catch(error => {
  //           console.error('Error fetching the file:', error);
  //           setError('Error fetching the file');
  //           setLoading(false);
  //         });
  //     } else {
  //       setLoading(false);
  //     }
  //   }, [file]);
  
  //   if (loading) {
  //     return <div>Loading...</div>;
  //   }
  
  //   if (error) {
  //     return <div>{error}</div>;
  //   }
  
  //   return fileContent ? (
  //     <pre>{JSON.stringify(fileContent, null, 2)}</pre>
  //   ) : (
  //     <div>File not found</div>
  //   );
  // };

  return (
    <Routes>
      <Route path="/IFP" element={<IFP files={files} />} />
      <Route path="/IFP/:fileName" element={<FileDownloader files={files} />} />
      <Route path="/CS" element={<CS files={files} />} />
      <Route path="/CS/:fileName" element={<FileDownloader files={files} />} />
    </Routes>
  );
};

export default App;